import { render, staticRenderFns } from "./TranshipmentNegotiationsByID.vue?vue&type=template&id=0522d200"
import script from "./TranshipmentNegotiationsByID.vue?vue&type=script&lang=js"
export * from "./TranshipmentNegotiationsByID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports